/* eslint-disable import/prefer-default-export */

// import { arrayHasLength } from '~utils/array';

export function mapItemsToCart({ items, addedByCoupon = false }) {
  if (!items) {
    return [];
  }
  return items
    .map((item) => {
      // Validar que item.modifiers existe
      const modifiers = item.modifiers || {};

      // Crear la estructura de items agrupados por parentId
      const groupedItems = {};

      if (Object.keys(modifiers).length > 0) {
        Object.keys(modifiers).forEach((key) => {
          const mods = modifiers[key];
          if (Array.isArray(mods)) {
            // Array de modificadores
            groupedItems[key] = mods.map(({ id, name, quantity, parentId }) => ({
              id,
              name,
              quantity: quantity || 1,
              parentId
            }));
          } else if (mods && typeof mods === 'object') {
            // Objeto individual
            groupedItems[key] = [
              {
                id: mods.id,
                name: mods.name,
                quantity: mods.quantity || 1,
                parentId: mods.parents[0]?.id,
                price: mods.price
              }
            ];
          }
        });
      }

      const result = {
        count: item.quantity || 1,
        specialRequirement: '',
        product: item,
        category: '',
        basePrice: item.discountPrice || item.price,
        addedByCoupon,
        items: groupedItems
      };
      return result;
    })
    .filter(Boolean);
}

export const mapResponse = (res, state) => {
  const updatedCart = res.data.items
    ? mapItemsToCart({ items: res.data.items, addedByCoupon: false })
    : state.cart.cart;

  return {
    ok: res.ok,
    data: {
      cart: updatedCart,
      subtotal: res.data.subtotal,
      total: res.data.total,
      delivery: res.data.delivery,
      deliveryMethod: res.data.deliveryMethod,
      uberEstimateId: res.data.uberEstimateId,
      uberEstimateExpiresAt: res.data.uberEstimateExpiresAt,
      deliveryDetails: res.data.deliveryDetails,
      discount: res.data.discount,
      coupon: res.data.coupon,
      loyaltyPoints: res.data.loyaltyProgram?.amount,
      maxLoyaltyMoneyToUse: res.data.maxLoyaltyMoneyToUse,
      error: {
        code: res.data.description,
        metadata: res.data.metadata
      }
    }
  };
};
